import styled from 'styled-components';

export const ContainerCenter = styled.div`
  height: 100vh;
  width: 100%;
  background-color: #eff1f5;
`;

export const TopDiv = styled.div`
  display: flex;
  width: 100%;
`;

export const MainContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  height: 100vh;
  min-height: 600px;
  min-width: 750px;
`;

export const ContainerCenterInside = styled.div`
  display: flex;
  position: relative;
  justify-content: center;
`;

export const ContainerCenterInsideLoading = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

export const FlowModelItem = styled.div`
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  width: 96%;
  height: 5.36rem;
  background: #ffffff;
  border-radius: 4.22206px;
  position: relative;
  filter: drop-shadow(0px 5.62941px 11.2588px rgba(88, 94, 102, 0.08));
  margin-bottom: 0.6rem;
  display: flex;

  &:hover {
    background: rgba(207, 248, 231, 0.6);
  }
`;

export const Dashboard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 3rem;
  user-select: none;
`;

export const LastModified = styled.div`
  font-family: Sora;
  font-style: normal;
  font-weight: 600;
  font-size: 0.8rem;
  color: #232323;
`;

export const DefaultVersionDiv = styled.div`
  font-family: Sora;
  font-style: normal;
  font-weight: 600;
  font-size: 0.8rem;
  user-select: none;
  color: #232323;
`;

export const TitleDiv = styled.div`
  font-family: Sora;
  font-style: normal;
  font-weight: 600;
  font-size: 0.94rem;
  margin-left: 2rem;
  color: #232323;
  align-self: center;
`;

export const ModifiedDiv = styled.div`
  position: absolute;
  font-family: Sora;
  font-style: normal;
  font-weight: normal;
  font-size: 0.74rem;
  line-height: 20px;
  left: 55%;
  /* identical to box height */

  text-align: center;

  color: #9c9c9c;
`;
export const ModifiedDiv2 = styled.div`
  position: absolute;
  font-family: Sora;
  font-style: normal;
  font-weight: normal;
  font-size: 0.74rem;
  line-height: 20px;
  left: 71%;
  /* identical to box height */

  text-align: center;

  color: #9c9c9c;
`;

export const Header = styled.div`
  width: 96%;
  display: flex;
  align-items: center;
  height: 2.68rem;
  margin-top: 2.5rem;
  user-select: none;
  position: relative;
`;

export const StyledDiv = styled.div`
  position: relative;
  width: 20.8rem;
  display: flex;
  align-items: center;
  height: 2.68rem;
`;

export const CustomInput = styled.input`
  line-height: 0.875rem;
  padding: 0.765rem 0 0.71375rem 0.6504rem;
  border: none;
  background-color: white;
  height: 2.68rem;

  line-height: 0.875rem;
  padding: 0.765rem 0 0.71375rem 0.6504rem;
  outline: none;
  box-sizing: border-box;
  outline: none;
  height: 100%;
  width: 100%;
  font-family: ${({ type, visible }) =>
    !visible && type === 'password' ? 'Sans-Serif' : 'Sora'};

  font-size: ${({ type, visible }) =>
    !visible && type === 'password' ? '1.25rem' : '0.70833rem'}; //0.70833rem;;

  letter-spacing: ${({ visible, type }) =>
    !visible && type === 'password' ? '0.25rem' : '0px'};

  color: ${({ type }) => (type === 'password' ? '#585e66' : '#111')};

  &:placeholder-shown {
    font-family: Sora;
    color: #a9aeb4;
    letter-spacing: 0px;
    font-size: 0.70833rem;
  }
`;
